import { render, staticRenderFns } from "./GlLogoApp.vue?vue&type=template&id=3b814153&scoped=true&"
import script from "./GlLogoApp.vue?vue&type=script&lang=js&"
export * from "./GlLogoApp.vue?vue&type=script&lang=js&"
import style0 from "./GlLogoApp.vue?vue&type=style&index=0&id=3b814153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b814153",
  null
  
)

export default component.exports